/**
 * Chart colour system for the analytics dashboards.
 *
 * Categorical slots are assigned in this fixed order and never cycled: a
 * series keeps its colour when a filter removes its neighbours. The order was
 * validated for colour-vision deficiency separation (adjacent pairs) and
 * lightness against a white surface; slots 3/5/6 sit below 3:1 contrast so
 * charts always carry a legend and direct labels rather than colour alone.
 *
 * Sequential encoding (heatmaps) is one hue, light -> dark. Status colours are
 * reserved for insight severity and never reused as a series.
 */
export const SERIES = [
  "#7c3aed", // purple  (recognitions / primary)
  "#eb6834", // orange
  "#1baf7a", // aqua
  "#2a78d6", // blue
  "#eda100", // yellow
  "#e87ba4", // magenta
  "#008300", // green
  "#e34948", // red
];

export const SERIES_ROLE = {
  primary: SERIES[0],
  secondary: SERIES[3],
  tertiary: SERIES[2],
  warm: SERIES[1],
  previous: "#b8b5c4", // previous-period overlay: neutral, never a series slot
  other: "#a3a3a3",
};

export const SEQUENTIAL = [
  "#f3ecfe", "#e4d5fd", "#cdb4fa", "#b28df5", "#9a6cf0", "#7c3aed", "#6428c7", "#4f1fa0",
];

export const STATUS = {
  good: "#0ca30c",
  warning: "#fab219",
  serious: "#ec835a",
  critical: "#d03b3b",
  info: "#2a78d6",
};

export const INK = {
  primary: "#0f172a",
  secondary: "#475569",
  muted: "#94a3b8",
  grid: "#e2e8f0",
  axis: "#cbd5e1",
};

/** A recognition type's own colour when it has one, else its slot. */
export const seriesColor = (index, own) => own || SERIES[index % SERIES.length];

/** Sequential step for a 0..1 value. */
export const sequential = (ratio) => {
  if (!ratio || ratio <= 0) return SEQUENTIAL[0];
  const idx = Math.min(SEQUENTIAL.length - 1, Math.ceil(ratio * (SEQUENTIAL.length - 1)));
  return SEQUENTIAL[idx];
};

export const TOOLTIP_STYLE = {
  borderRadius: "10px",
  border: "1px solid #e2e8f0",
  boxShadow: "0 4px 16px rgba(15, 23, 42, 0.08)",
  fontSize: "12px",
  padding: "8px 10px",
};

export const AXIS_TICK = { fontSize: 11, fill: INK.secondary };
export const AXIS_TICK_SMALL = { fontSize: 9, fill: INK.secondary };
